import React from "react";
import PropTypes from "prop-types";
import Alert from "@shared/v2/Alert";

const FormErrors = ({ formErrors }) => (
  <Alert
    title={`There were ${Object.keys(formErrors).length} errors.`}
    variant="error"
    text={Object.entries(formErrors).map(([name, messages]) => (
      <div key={`error-${name}`}>
        {name}: {messages.join(", ")}
      </div>
    ))}
  />
);

FormErrors.propTypes = {
  formErrors: PropTypes.shape().isRequired,
};

export default FormErrors;
